// Trilingual content IT / EN / DE for Vico's Scooter — Alta Badia
export const translations = {
  it: {
    brand: { name: "Vico's Scooter", tag: "Alta Badia" },
    nav: { fleet: "Modello", how: "Come funziona", routes: "Itinerari", pricing: "Prezzi", availability: "Disponibilità", gallery: "Galleria", faq: "FAQ", login: "Accedi", logout: "Esci", dashboard: "I miei noleggi", admin: "Admin", book: "Prenota Ora" },
    hero: {
      kicker: "Alta Badia · Dolomiti",
      // Title structure: "Vivi le Dolomiti in modo {Nuovo}!"
      title_pre: "Vivi le Dolomiti",
      title_mid: "in modo",
      title_accent: "Nuovo",
      title_end: "!",
      sub: "Noleggia uno scooter 100% elettrico per goderti le Dolomiti senza rumore, senza emissioni e senza limiti!",
      cta: "Prenota il tuo Scooter",
      cta2: "Scopri il mezzo",
      electric_chip: "100% Elettrico",
    },
    showcase: {
      label: "La flotta di",
      title: "Vico's Scooter",
      zero_emissions: "Zero emissioni",
      desc: "Nuovo scooter 100% elettrico. Massima sicurezza con sistemi di ABS e TCS. Agile e divertente, dotato di varie modalità di guida e fino a 100 km di autonomia.",
      specs: { range: "Autonomia", speed: "Velocità max", abs_tcs: "ABS + TCS", security: "Sicurezza", riders: "Posti", power: "Potenza max", license: "Patente", age: "Età minima", helmet: "Casco", yes: "Incluso", riders_v: "2 persone" },
    },
    how: { label: "Come funziona", title: "Tre passi.\nZero attriti.", s1t: "Scegli le date", s1d: "Apri il calendario, seleziona giorno di partenza e ritorno.", s2t: "Conferma", s2d: "Inserisci i tuoi dati. Riceverai una mail di conferma immediata.", s3t: "Guida", s3d: "Ritira lo scooter alla nostra sede di San Cassiano o richiedi consegna in hotel." },
    routes: {
      label: "Itinerari", title: "Le rotte\ndelle Dolomiti.",
      intro: "Con lo scooter elettrico ti muovi senza fatica tra i passi, eviti le code dei pullman turistici e trovi parcheggio facilmente — soprattutto nelle città come Cortina e Brunico dove l'auto è sempre un problema.",
      stats: { distance: "Distanza", duration: "Durata", elev: "Dislivello" },
      cta: "Prenota questo itinerario",
      cta_short: "Prenota",
      download_gpx: "Scarica GPX",
      open_maps: "Apri su Google Maps",
      items: [
        {
          id: "4passi",
          title: "Il Giro dei 4 Passi",
          desc: "Il classico anello della Sella Ronda affrontato come lo si dovrebbe fare: in scooter. Sali sul Pordoi, scollini al Sella, scendi sul Gardena e chiudi sul Campolongo. Senza marce da cambiare, senza stress, e con la natura tutta intorno.",
          stats: { distance: "55 km", duration: "3 h", elev: "+1 800 m" },
        },
        {
          id: "cortina",
          title: "San Cassiano → Cortina",
          desc: "Passo Falzarego, le 5 Torri sulla destra, poi giù verso la Regina delle Dolomiti. In auto cerchi parcheggio per ore — in scooter ti fermi davanti a Corso Italia, vai a pranzo e riparti. Semplicemente facile.",
          stats: { distance: "35 km", duration: "1 h 15", elev: "+700 m" },
        },
        {
          id: "brunico",
          title: "San Cassiano → Brunico",
          desc: "La discesa più dolce: La Villa, Longega, Val Badia bassa fino a Brunico. Perfetto per fare shopping in centro storico, visitare il MMM Ripa e tornare entro sera. Il parcheggio in centro a Brunico è un incubo per le macchine — per te, due secondi.",
          stats: { distance: "30 km", duration: "45 min", elev: "−400 m" },
        },
      ],
    },
    pricing: { label: "Tariffe", title: "Tre tariffe semplici", half: "Mezza giornata", full: "Giornaliera", multi: "Multi-giorno", per: "per scooter", popular: "Più richiesto", coming_soon: "In arrivo", per_day: "/giorno", flat: "fisso", full_desc: "1 o 2 giorni · giornata intera", multi_desc: "Da 3 giorni in su · prezzo scontato", half_desc: "Mattina o pomeriggio · fino a 4 ore" },
    gallery: { label: "Galleria", title: "Momenti sui nostri scooter" },
    avail: { label: "Disponibilità", title: "Calendario disponibilità", hint: "I giorni con scooter ancora liberi sono evidenziati. Seleziona un intervallo per prenotare." },
    hygiene: {
      label: "Igiene & Sicurezza",
      title: "Caschi sanificati.\nSottocaschi in regalo.",
      intro: "La tua salute viene prima di tutto. Ogni casco viene sanificato dopo ogni utilizzo con prodotti professionali, e per ogni noleggio ti regaliamo un sottocasco monouso — igienico, fresco e sempre nuovo.",
      free_badge: "Sottocaschi gratuiti · inclusi nel noleggio",
      item1_title: "Sanificazione professionale",
      item1_desc: "Ogni casco viene igienizzato con spray antibatterico e UV-C dopo ogni utilizzo. Zero condivisione di sudore, batteri o cattivi odori.",
      item2_title: "Sottocaschi in omaggio",
      item2_desc: "Ti regaliamo un sottocasco monouso in tessuto traspirante per ogni noleggio. Comfort, freschezza e igiene totale sotto il casco.",
      item3_title: "Sicurezza certificata",
      item3_desc: "Caschi omologati ECE 22.06, controllati regolarmente. Taglie S, M, L disponibili — provale prima di partire.",
    },
    faq: {
      label: "Domande", title: "Risposte rapide",
      items: [
        { q: "Serve la patente?", a: "Sì. Per il NIU NQiX 500 serve la patente B (auto) oppure la A1 (motociclo). Inoltre è richiesta un'età minima di 18 anni." },
        { q: "Il casco è obbligatorio?", a: "Sì, il casco è obbligatorio per legge e viene sempre fornito incluso nel noleggio. Puoi scegliere taglie S, M o L durante la prenotazione." },
        { q: "Posso annullare?", a: "Sì, la cancellazione è consentita solo fino a 24h prima del ritiro. Dopo tale termine non sono previsti rimborsi." },
        { q: "Quanto dura la batteria?", a: "Il NIU NQiX 500 monta due batterie estraibili 72V 28Ah per un'autonomia complessiva di circa 95 km — più che sufficiente per una giornata di esplorazione." },
        { q: "E se piove?", a: "Nessun problema: lo scooter è impermeabile e omologato per la circolazione stradale in ogni condizione meteo." },
      ],
    },
    footer: { tag: "Let's Ride.", contact: "Contatti", location: "Sede", hours: "Orari", rights: "Tutti i diritti riservati." },
    book: {
      title: "Prenota il tuo Vico's Scooter",
      step1: "Date", step2: "Quantità e caschi", step3: "Contatti",
      start: "Inizio", end: "Fine", qty: "Numero scooter", tier: "Tariffa",
      name: "Nome completo", email: "Email", phone: "Telefono", notes: "Note (opzionale)",
      summary: "Riepilogo", total: "Totale stimato", confirm: "Conferma prenotazione",
      success: "Prenotazione ricevuta!", success_d: "Riceverai a breve un'email di conferma. Ti contatteremo per i dettagli del ritiro.",
      next: "Avanti", back: "Indietro",
      auto_tier: "Tariffa applicata automaticamente in base ai giorni",
      pay_redirect: "Pagamento sicuro tramite Stripe · carta o Apple/Google Pay",
      helmets_title: "Caschi inclusi",
      helmets_sub: "Casco e bauletto sempre inclusi · casco extra +€{extra_helmet} · max 2 caschi per scooter.",
      helmets_count: "Caschi totali",
      helmets_warn: "Suggerito almeno 1 casco per scooter.",
      helmets_max: "Massimo 2 caschi per scooter raggiunto.",
      helmet_fee_line: "Caschi extra",
      half_day_toggle: "Solo pomeridiano · €{half_day} fisso",
      pickup: "Ritiro",
      return: "Riconsegna",
      same_day: "Stesso giorno",
      select_dates: "Tocca un giorno sul calendario",
      select_dates_hint: "Tocca un giorno per il noleggio singolo · Tocca due giorni per più giorni",
      duration_choice: "Durata del noleggio",
      slot_choice: "Fascia oraria",
      slot_morning: "Mattina",
      slot_afternoon: "Pomeriggio",
      slot_past: "Fascia passata",
      custom_hours_call: "Per info e orari personalizzati chiamaci al +39 335 6116528",
      half_day_option: "Mezza giornata",
      half_day_option_d: "Pomeriggio · fino a 4h · €{half_day} fisso",
      full_day_option: "Giornata intera",
      full_day_option_d: "9h · €{full_day}",
      full_day_same_day_locked: "Solo dal giorno successivo",
      same_day_notice: "Per prenotare per oggi puoi scegliere solo la mezza giornata pomeridiana (riconsegna entro le 17:00).",
      today_multiday_blocked: "Il noleggio giornaliero o multi-giorno deve essere prenotato entro il giorno precedente. Scegli una data che parte da domani.",
      age_confirm: "Confermo che sia chi prenota sia chi guiderà lo scooter hanno almeno 18 anni e una patente valida (B o A1).",
      age_required: "Devi confermare il requisito di età per procedere",
      topcase_title: "Bauletto (opzionale)",
      topcase_sub: "Aggiungi un bauletto rigido allo scooter per portare zaini, spesa e oggetti personali. Max 1 per scooter.",
      topcase_label: "Bauletti · €20 cad.",
      available_label: "disponibili",
      sold_out: "Non disponibile in queste date",
      phone_required: "Il numero di telefono è obbligatorio",
      pending_title: "Prenotazione in corso",
      pending_next_step: "Prossimo step",
      pending_step_license: "Carica patente",
      pending_step_contract: "Firma contratto",
      pending_step_pay: "Pagamento",
      pending_resume: "Riprendi",
      pending_cancel: "Annulla e ricomincia",
      resumed: "Prenotazione ripresa · continua da dove avevi lasciato",
      resume_failed: "Impossibile riprendere la prenotazione",
      cancelled: "Prenotazione annullata",
      recovery_open: "Ho perso il link",
      recovery_title: "Recupera prenotazione",
      recovery_desc: "Inserisci la tua email: se hai una prenotazione in sospeso, ti mandiamo il link per riprenderla.",
      recovery_send: "Manda il link",
      recovery_sent: "Se hai una prenotazione in sospeso, ti abbiamo mandato il link via email.",
      recovery_failed: "Errore invio email di recupero",
      continue_license: "Continua",
      continue_pay: "Vai al pagamento",
      step_license_hint: "Compila i dati patente qui sopra per procedere",
      continue_sign: "Continua alla firma",
      sign_title: "Firma il trattamento dei dati",
      sign_sub: "Firma il modulo qui sotto. Il pagamento verrà sbloccato automaticamente non appena la firma sarà registrata.",
      sign_waiting: "In attesa della firma…",
      sign_done: "Firma ricevuta ✓ · puoi procedere al pagamento",
      sign_iframe_hint: "Se il modulo non appare, ",
      sign_iframe_open: "aprilo in una nuova scheda",
      sign_refresh: "Ho firmato — Controlla",
      sign_refresh_none: "Firma non ancora ricevuta. Riprova tra qualche secondo.",
      sign_refresh_ok: "Firma trovata! Puoi procedere al pagamento.",
      choose_scooter: "Scegli il tuo scooter",
      pickup_point: "Punto di ritiro e riconsegna",
      pickup_point_hint: "Ritiri e riconsegni lo scooter nello stesso punto.",
      pickup_hotel_label: "Nome del tuo hotel *",
      pickup_hotel_placeholder: "Es. Hotel Ai Pini",
      pickup_hotel_hint: "Verremo a consegnarti lo scooter direttamente presso l'hotel indicato.",
      pickup_hotel_hint_short: "Inserisci il nome del tuo hotel",
      choose_scooter_hint: "Ogni scooter è un mezzo unico: seleziona quello (o quelli) che vuoi guidare.",
      unit_busy: "Occupato",
      unit_selected: "Selezionato",
      select_scooter_required: "Seleziona almeno uno scooter",
      your_scooters: "I tuoi scooter",
    },
    contract: {
      title: "Contratto di noleggio",
      subtitle: "Compila e firma il contratto. Il pagamento sarà sbloccato dopo la firma.",
      loading: "Caricamento dati contratto…",
      ai_prefill: "I dati della patente sono stati precompilati con AI. Verifica e modifica se necessario.",
      sec_personal: "Dati anagrafici",
      sec_residence: "Residenza",
      sec_license: "Dati patente",
      sec_id: "Documento di identità",
      sec_rental: "Riepilogo noleggio",
      sec_sign: "Firma",
      family_name: "Cognome",
      given_names: "Nome",
      birthplace: "Luogo di nascita",
      birthdate: "Data di nascita",
      street: "Via",
      number: "N°",
      city: "Città",
      zip: "CAP",
      province: "Provincia",
      country: "Nazione",
      phone: "Cellulare",
      email: "Email",
      fiscal_code: "Codice fiscale",
      license_number: "N° patente",
      license_category: "Categoria",
      license_issue_date: "Data rilascio",
      license_issuing_country: "Paese rilascio",
      license_expiry: "Scadenza",
      id_type: "Tipo documento",
      id_type_id_card: "Carta d'identità",
      id_type_passport: "Passaporto",
      id_number: "Numero",
      id_issue_date: "Data rilascio",
      id_issuer: "Rilasciato da",
      id_expiry: "Scadenza",
      scooters: "Scooter",
      plate: "targa",
      sign_here: "Firma qui sotto",
      sign_clear: "Cancella",
      sign_hint: "Firma con il mouse o il dito nell'area bianca.",
      accept_terms: "Accetto specificamente le clausole 2, 4, 5, 7, 9, 10, 11, 12 delle condizioni generali di noleggio (art. 1341 e 1342 c.c.).",
      accept_privacy: "Ho letto e accetto l'informativa sul trattamento dei dati personali (GDPR).",
      confirm_data: "Confermo che i dati inseriti dalla patente e dalla carta d'identità sono corretti e veritieri.",
      sign_submit: "Firma il contratto",
      signing: "Firma in corso…",
      signed_ok: "Contratto firmato ✓",
      signed_title: "Contratto firmato",
      signed_desc: "Puoi procedere al pagamento sicuro tramite Stripe.",
      signed_short: "Contratto firmato ✓",
      step_hint: "Firma il contratto per procedere",
      fill_required: "Compila tutti i campi obbligatori, firma e accetta i termini",
      preview_label: "Anteprima contratto",
      preview_desc: "Visualizza il contratto completo con i tuoi dati compilati PRIMA di firmarlo. Obbligatorio.",
      preview_open: "Mostra anteprima del contratto",
      preview_review_again: "Rivedi anteprima",
      preview_loading: "Generazione anteprima…",
      preview_failed: "Impossibile generare l'anteprima",
      preview_first: "Visualizza prima l'anteprima del contratto",
      preview_need_fields: "Completa prima i campi obbligatori sopra.",
      preview_modal_label: "Anteprima · specimen",
      preview_modal_title: "Rivedi il contratto prima di firmare",
      preview_modal_hint: "Scorri per rivedere tutte le pagine. Quando sei pronto chiudi questa finestra e firma.",
      preview_modal_confirm: "Ho letto · procedi alla firma",
      id_autofill_label: "Compila con la carta d'identità",
      id_autofill_desc: "Scatta o carica una foto del fronte E del retro della tua carta d'identità: compileremo automaticamente tutti i dati (residenza, codice fiscale, numero documento…).",
      id_photo_label: "Fronte carta d'identità",
      id_photo_label_front: "Fronte",
      id_photo_label_back: "Retro",
      id_extracting: "Estrazione dati…",
      id_autofilled: "Dati estratti dal documento ✓ verifica e correggi se serve",
      id_back_autofilled: "Dati del retro estratti ✓ (residenza aggiornata)",
      id_autofilled_badge: "Compilato dal documento",
      id_unreadable: "Foto documento non leggibile: riprova con una foto più nitida",
      id_back_unreadable: "Foto retro non leggibile: riprova con una foto più nitida",
      download: "Scarica PDF",
    },
    auth: { signin: "Accedi", signup: "Registrati", email: "Email", password: "Password", name: "Nome", google: "Continua con Google", or: "oppure", sin: "Entra", sup: "Crea account", err: "Errore" },
    payment: {
      cancel_title: "Cancellazione flessibile",
      cancel_desc: "Puoi annullare la tua prenotazione fino a 24 ore prima del ritiro e ricevere il rimborso completo. Per annullare, scrivi a info@vicotravel.it o chiama il +39 335 6116528.",
    },
    dash: { title: "I miei noleggi", empty: "Nessuna prenotazione ancora. Prenota il tuo primo NIU NQiX 500!", scooter: "Scooter", dates: "Date", qty: "Quantità", total: "Totale", status: "Stato" },
    admin: {
      title: "Pannello Admin", subtitle: "Gestione prenotazioni e flotta",
      stats: { total: "Prenotazioni", pending: "In attesa", confirmed: "Confermate", cancelled: "Annullate", revenue: "Fatturato stimato" },
      tabs: { bookings: "Prenotazioni", customers: "Clienti", fleet: "Flotta", gallery: "Galleria", calendar: "Calendario", analytics: "Analytics", account: "Account" },
      filter_all: "Tutte", confirm: "Conferma", cancel: "Annulla", delete: "Elimina", confirm_delete: "Eliminare definitivamente?",
      empty: "Nessuna prenotazione",
      fleet_units: "Numero scooter", fleet_full_day: "Tariffa giornaliera (€)", fleet_half_day: "Pomeridiano (€)", fleet_multi_day: "Tariffa multi-giorno (€)", fleet_extra_helmet: "Casco extra (€/cad)", fleet_topcase: "Bauletto (€/cad)", save: "Salva modifiche", saved: "Modifiche salvate",
      units_title: "Scooter individuali",
      units_sub: "Targa e codice assicurazione sono visibili solo qui nel pannello admin — mai sul sito pubblico.",
      unit_name: "Nome pubblico",
      loc_title: "Punti di ritiro e riconsegna",
      loc_subtitle: "Il cliente sceglie uno di questi punti durante la prenotazione. Ritiro e riconsegna avvengono nello stesso punto.",
      loc_add_title: "Aggiungi punto",
      loc_name: "Nome (es. Camping Sass Dlacia)",
      loc_address: "Indirizzo",
      loc_notes: "Orari / note (es. ritiro dalle 9:00)",
      loc_add: "Aggiungi",
      loc_customer_label: "Il cliente sceglie l'indirizzo",
      loc_customer_hint: "Usa questa opzione per punti generici (es. \"Il tuo hotel\") dove sarà il cliente a specificare il nome della struttura in fase di prenotazione.",
      loc_customer_badge: "Indirizzo dal cliente",
      loc_address_locked: "Il cliente inserirà il nome dell'hotel al momento della prenotazione",
      gallery_title: "Galleria pubblica",
      gallery_sub: "Le foto compariranno nella sezione Galleria della homepage.",
      gallery_empty: "Nessuna foto ancora. Aggiungine una qui sotto.",
      gallery_add_title: "Aggiungi foto",
      gallery_caption_ph: "Commento sotto la foto (facoltativo)",
      gallery_add: "Aggiungi alla galleria",
      gallery_added: "Foto aggiunta",
      gallery_too_big: "Immagine troppo grande (max 8 MB)",
      gallery_pick_photo: "Scegli una foto",
      loc_added: "Punto aggiunto",
      loc_removed: "Punto rimosso",
      loc_name_required: "Nome del punto obbligatorio",
      loc_delete_confirm: "Rimuovere questo punto di ritiro?",
      loc_empty: "Nessun punto configurato — i clienti non vedranno la scelta.",
      unit_plate: "Targa",
      unit_insurance: "Codice assicurazione",
      unit_saved: "Scooter aggiornato",
      access_denied: "Accesso negato. Solo amministratori.",
      helmets: "Caschi",
      topcase: "Bauletto",
      cal_title: "Disponibilità giornaliera",
      cal_sub: "Vedi quanti scooter sono liberi ogni giorno e blocca temporaneamente unità per manutenzione.",
      cal_available: "Liberi",
      cal_booked: "Prenotati",
      cal_blocked: "Bloccati",
      block_title: "Blocco temporaneo",
      block_sub: "Riserva N scooter per manutenzione o uso interno.",
      block_qty: "Numero scooter da bloccare",
      block_start: "Dal",
      block_end: "Al",
      block_notes: "Note (opzionale)",
      block_btn: "Crea blocco",
      block_created: "Blocco creato",
      an_title: "Analytics revenue",
      an_total_rev: "Ricavi totali",
      an_total_bk: "Prenotazioni",
      an_avg_ticket: "Ticket medio",
      visits_title: "Visite al sito",
      visits_today: "Oggi",
      visits_7d: "Ultimi 7 giorni",
      visits_30d: "Ultimi 30 giorni",
      visits_unique: "unici",
      visits_all: "totali",
      visits_visits: "Visite",
      visits_book_clicks: "Click su Prenota",
      visits_referrers: "Sorgenti principali (30 gg)",
      an_revenue_chart: "Entrate mensili (€)",
      an_bookings_chart: "Prenotazioni per mese",
      pw_title: "Cambia password",
      pw_sub: "Aggiorna la password del tuo account admin. Minimo 6 caratteri.",
      pw_current: "Password attuale",
      pw_new: "Nuova password",
      pw_confirm: "Conferma nuova password",
      pw_save: "Aggiorna password",
      push_title: "Notifiche push sul telefono",
      push_sub: "Attivale su questo dispositivo per ricevere una notifica appena arriva una nuova prenotazione o un pagamento.",
      push_unsupported: "Il tuo browser non supporta le notifiche push. Su iPhone aggiungi il sito alla schermata Home (Safari → Condividi → Aggiungi a Home), poi riapri l'app dalla Home e riprova.",
      push_status: "Stato su questo dispositivo",
      push_on: "ATTIVE",
      push_off: "DISATTIVE",
      push_denied: "· permesso bloccato dal browser",
      push_enable: "Attiva notifiche",
      push_disable: "Disattiva",
      push_test: "Invia test",
      push_test_sent: "Notifica di test inviata",
      push_enabled: "Notifiche push attive su questo dispositivo",
      push_disabled: "Notifiche push disattivate",
      push_hint: "Su iPhone (iOS 16.4+): aggiungi vico-scooter.it alla schermata Home (Safari → Condividi → \"Aggiungi a Home\"), apri l'app dalla Home e clicca Attiva. Su Android: funziona direttamente da Chrome/Edge/Firefox.",
      pw_changed: "Password aggiornata con successo",
      pw_mismatch: "Le password non coincidono",
      pw_min: "La password deve avere almeno 6 caratteri",
      pw_all_fields: "Compila tutti i campi",
      gran_month: "Mese", gran_week: "Settimana", gran_day: "Giorno",
      notif_title: "Notifiche",
      notif_new: "Nuova prenotazione",
      notif_empty: "Nessuna nuova prenotazione",
      notif_clear: "Svuota",
      notif_enable: "Attiva notifiche desktop",
      notif_enabled: "Notifiche desktop attivate",
      gran_now: "Oggi",
      cust_title: "Database clienti",
      cust_search: "Cerca per nome, email o telefono...",
      cust_export: "Esporta CSV",
      cust_empty: "Nessun cliente al momento",
      cust_bookings: "Prenotazioni",
      cust_total: "Totale speso",
      cust_all_bookings: "Tutte le prenotazioni",
      cust_notes: "Note",
      view_license: "Vedi patente",
      license_title: "Documento del guidatore",
      license_none: "Nessuna patente caricata",
      license_delete: "Elimina",
      license_delete_confirm: "Eliminare definitivamente foto e dati patente?",
      license_deleted: "Patente eliminata",
      license_expires_in: "Cancellazione fra",
      license_expiring_today: "Verrà eliminata oggi",
      contract_signed: "Contratto firmato",
      ai_verified: "AI Verified",
      download_contract: "Scarica contratto",
      contract_download_failed: "Impossibile scaricare il contratto",
    },
    license: {
      title: "Carica la tua patente",
      subtitle: "Per completare la prenotazione ti chiediamo di caricare i dati e la foto della patente. Servirà al ritiro dello scooter.",
      driver_name: "Nome e cognome guidatore",
      birthdate: "Data di nascita",
      number: "Numero patente",
      expiry: "Data scadenza",
      country: "Paese di rilascio",
      is_intl_q: "La mia patente è internazionale?",
      intl_yes_hint: "Devi caricare sia la patente nazionale sia quella internazionale.",
      intl_no_hint: "Ti basta caricare la patente del tuo Paese.",
      national_photos: "Foto patente nazionale",
      intl_photos: "Foto patente internazionale",
      front: "Fronte",
      back: "Retro",
      front_required: "Fronte (obbligatorio)",
      back_required: "Retro (obbligatorio)",
      submit: "Invia dati patente",
      saved: "Patente registrata con successo",
      fill_required: "Compila tutti i dati richiesti",
      upload_national: "Carica il fronte della patente nazionale",
      upload_national_back: "Carica il retro della patente nazionale",
      upload_international: "Carica il fronte della patente internazionale",
      upload_international_back: "Carica il retro della patente internazionale",
      take_photo: "Scatta foto",
      pick_gallery: "Galleria",
      retake: "Rifai foto",
      replace: "Cambia",
      upload_image: "Carica immagine",
      upload_hint_desktop: "JPG · PNG · max 5MB",
      autofill_hint: "Scatta o carica prima la foto della patente: compileremo i campi automaticamente.",
      extracting: "Estrazione dati…",
      autofilled: "Dati estratti dalla patente ✓ verifica e correggi se serve",
      autofilled_badge: "Compilato dalla foto",
      data_label: "Dati patente",
      verify_hint: "I dati digitati verranno confrontati automaticamente con quelli sulla foto della patente. Assicurati che la foto sia nitida e ben illuminata.",
      done_title: "Tutto pronto!",
      done_sub: "I tuoi dati sono stati registrati. Ci vediamo a San Cassiano — porta con te il documento originale al ritiro.",
    },
  },
  en: {
    brand: { name: "Vico's Scooter", tag: "Alta Badia" },
    nav: { fleet: "The Ride", how: "How it works", routes: "Itineraries", pricing: "Pricing", availability: "Availability", gallery: "Gallery", faq: "FAQ", login: "Sign in", logout: "Log out", dashboard: "My bookings", admin: "Admin", book: "Book Now" },
    hero: {
      kicker: "Alta Badia · Dolomites",
      // Title: "Ride the Dolomites in a {NEW} way!"
      title_pre: "Ride the Dolomites",
      title_mid: "in a",
      title_accent: "NEW",
      title_end: "way!",
      sub: "Rent an E-scooter to enjoy the Dolomites with zero noise, zero emissions, and no limits!",
      cta: "Book Your Scooter",
      cta2: "See the machine",
      electric_chip: "100% Electric",
    },
    showcase: {
      label: "The fleet of",
      title: "Vico's Scooter",
      zero_emissions: "Zero emissions",
      desc: "The new 100% electric scooter. Maximum safety with ABS and TCS. Agile and fun, featuring multiple riding modes and a range of up to 100 km.",
      specs: { range: "Range", speed: "Top speed", abs_tcs: "ABS + TCS", security: "Safety", riders: "Riders", power: "Max power", license: "Licence", age: "Min age", helmet: "Helmet", yes: "Included", riders_v: "2 riders" },
    },
    how: { label: "How it works", title: "Three steps.\nZero friction.", s1t: "Pick dates", s1d: "Open the calendar, pick pickup and return days.", s2t: "Confirm", s2d: "Enter your details. You'll get an instant confirmation email.", s3t: "Ride", s3d: "Pick up at our San Cassiano shop or request hotel delivery." },
    routes: {
      label: "Itineraries", title: "The Dolomite\nroutes.",
      intro: "On an electric scooter you weave through the passes effortlessly, skip the tour-bus queues and park anywhere — especially in cities like Cortina and Brunico where finding a car spot is always a nightmare.",
      stats: { distance: "Distance", duration: "Duration", elev: "Elevation" },
      cta: "Book this itinerary",
      cta_short: "Book",
      download_gpx: "Download GPX",
      open_maps: "Open in Google Maps",
      items: [
        {
          id: "4passi",
          title: "The 4 Passes Loop",
          desc: "The classic Sella Ronda ring done the way it should be — on a scooter. Climb the Pordoi, crest the Sella, descend the Gardena and close on the Campolongo. No gears to shift, no stress, just nature all around.",
          stats: { distance: "55 km", duration: "3 h", elev: "+1 800 m" },
        },
        {
          id: "cortina",
          title: "San Cassiano → Cortina",
          desc: "Falzarego Pass, the 5 Towers on your right, then down to the Queen of the Dolomites. By car you hunt parking for hours — on a scooter you stop right on Corso Italia, have lunch and ride on. Just easy.",
          stats: { distance: "35 km", duration: "1 h 15", elev: "+700 m" },
        },
        {
          id: "brunico",
          title: "San Cassiano → Brunico",
          desc: "The mellowest descent: La Villa, Longega, lower Val Badia all the way to Brunico. Perfect for shopping in the old town, visiting MMM Ripa and getting back by evening. Parking in central Brunico is a car nightmare — for you, two seconds.",
          stats: { distance: "30 km", duration: "45 min", elev: "−400 m" },
        },
      ],
    },
    pricing: { label: "Rates", title: "Three simple rates", half: "Half day", full: "Daily", multi: "Multi-day", per: "per scooter", popular: "Best value", coming_soon: "Coming soon", per_day: "/day", flat: "flat", full_desc: "1 or 2 days · full day", multi_desc: "3 days or more · discounted", half_desc: "Morning or afternoon · up to 4 hours" },
    gallery: { label: "Gallery", title: "Moments on our scooters" },
    avail: { label: "Availability", title: "Live availability", hint: "Days with scooters left are highlighted. Select a range to book." },
    hygiene: {
      label: "Hygiene & Safety",
      title: "Sanitized helmets.\nFree hair liners.",
      intro: "Your health comes first. Every helmet is professionally sanitized after each use, and every rental includes a free disposable hair liner — hygienic, fresh, always brand new.",
      free_badge: "Hair liners free · included in every rental",
      item1_title: "Professional sanitizing",
      item1_desc: "Every helmet is disinfected with antibacterial spray and UV-C light after each use. No shared sweat, no bacteria, no odours.",
      item2_title: "Free disposable liners",
      item2_desc: "We give you a free breathable disposable hair liner for every rental. Comfort, freshness and total hygiene under the helmet.",
      item3_title: "Certified safety",
      item3_desc: "ECE 22.06 approved helmets, regularly inspected. Sizes S, M, L available — try them before you ride.",
    },
    faq: {
      label: "Questions", title: "Quick answers",
      items: [
        { q: "Do I need a licence?", a: "Yes. For the NIU NQiX 500 you need either a B (car) licence or an A1 (motorcycle) licence. Minimum age is 18." },
        { q: "Is a helmet mandatory?", a: "Yes, a helmet is mandatory by law and is always included. You can pick sizes S, M or L during booking." },
        { q: "Can I cancel?", a: "Yes, cancellations are only allowed up to 24h before pickup. After that, no refund is available." },
        { q: "How long does the battery last?", a: "The NIU NQiX 500 carries two swappable 72V 28Ah batteries for a combined range of ~95 km — more than enough for a day of exploration." },
        { q: "What if it rains?", a: "No problem: the scooter is fully waterproof and road-homologated for any weather condition." },
      ],
    },
    footer: { tag: "Let's Ride.", contact: "Contact", location: "Where", hours: "Hours", rights: "All rights reserved." },
    book: {
      title: "Book your Vico's Scooter",
      step1: "Dates", step2: "Quantity & helmets", step3: "Contact",
      start: "Start", end: "End", qty: "Scooters", tier: "Rate",
      name: "Full name", email: "Email", phone: "Phone", notes: "Notes (optional)",
      summary: "Summary", total: "Estimated total", confirm: "Confirm booking",
      success: "Booking received!", success_d: "You'll get a confirmation email shortly. We'll contact you for pickup details.",
      next: "Next", back: "Back",
      auto_tier: "Rate auto-applied based on duration",
      pay_redirect: "Secure payment via Stripe · card or Apple/Google Pay",
      helmets_title: "Included helmets",
      helmets_sub: "First helmet included · each extra helmet +€{extra_helmet} · max 2 per scooter.",
      helmets_count: "Total helmets",
      helmets_warn: "Suggested at least 1 helmet per scooter.",
      helmets_max: "Maximum 2 helmets per scooter reached.",
      helmet_fee_line: "Extra helmets",
      half_day_toggle: "Afternoon only · €{half_day} flat",
      pickup: "Pick-up",
      return: "Return",
      same_day: "Same day",
      select_dates: "Tap a day on the calendar",
      select_dates_hint: "Tap one day for a single rental · Tap two days for multi-day",
      duration_choice: "Rental duration",
      slot_choice: "Time slot",
      slot_morning: "Morning",
      slot_afternoon: "Afternoon",
      slot_past: "Slot passed",
      custom_hours_call: "For custom times & info, call us at +39 335 6116528",
      half_day_option: "Half day",
      half_day_option_d: "Afternoon · up to 4h · €{half_day} flat",
      full_day_option: "Full day",
      full_day_option_d: "9h · €{full_day}",
      full_day_same_day_locked: "From tomorrow only",
      same_day_notice: "For same-day booking only the afternoon half-day is available (return by 17:00).",
      today_multiday_blocked: "Full-day or multi-day rentals must be booked the day before. Pick a start date from tomorrow.",
      age_confirm: "I confirm that both the booker and the person riding the scooter are at least 18 years old and hold a valid licence (B or A1).",
      age_required: "You must confirm the age requirement to proceed",
      topcase_title: "Top case (optional)",
      topcase_sub: "Add a hard top case to carry backpacks, groceries and personal items. Max 1 per scooter.",
      topcase_label: "Top cases · €20 each",
      available_label: "available",
      sold_out: "Not available for these dates",
      phone_required: "Phone number is required",
      pending_title: "Booking in progress",
      pending_next_step: "Next step",
      pending_step_license: "Upload licence",
      pending_step_contract: "Sign contract",
      pending_step_pay: "Payment",
      pending_resume: "Resume",
      pending_cancel: "Cancel and restart",
      resumed: "Booking resumed · continue from where you left off",
      resume_failed: "Could not resume booking",
      cancelled: "Booking cancelled",
      recovery_open: "Lost my link",
      recovery_title: "Recover booking",
      recovery_desc: "Enter your email: if you have a pending booking, we'll send you the resume link.",
      recovery_send: "Send link",
      recovery_sent: "If you have a pending booking, we've emailed you the resume link.",
      recovery_failed: "Recovery email failed",
      continue_license: "Continue",
      continue_pay: "Go to payment",
      step_license_hint: "Fill in the licence details above to continue",
      continue_sign: "Continue to signature",
      sign_title: "Sign the data-processing agreement",
      sign_sub: "Sign the document below. Payment will unlock automatically once the signature is registered.",
      sign_waiting: "Waiting for signature…",
      sign_done: "Signature received ✓ · you can proceed to payment",
      sign_iframe_hint: "If the form doesn't appear, ",
      sign_iframe_open: "open it in a new tab",
      sign_refresh: "I signed — Check now",
      sign_refresh_none: "Signature not received yet. Try again in a few seconds.",
      sign_refresh_ok: "Signature found! You can proceed to payment.",
      choose_scooter: "Choose your scooter",
      pickup_point: "Pickup & return point",
      pickup_point_hint: "You pick up and return the scooter at the same point.",
      pickup_hotel_label: "Your hotel name *",
      pickup_hotel_placeholder: "e.g. Hotel Ai Pini",
      pickup_hotel_hint: "We'll deliver the scooter directly to your hotel.",
      pickup_hotel_hint_short: "Enter your hotel name",
      choose_scooter_hint: "Each scooter is a unique vehicle: pick the one(s) you want to ride.",
      unit_busy: "Booked",
      unit_selected: "Selected",
      select_scooter_required: "Select at least one scooter",
      your_scooters: "Your scooters",
    },
    contract: {
      title: "Rental contract",
      subtitle: "Fill in and sign the contract. Payment will unlock after signing.",
      loading: "Loading contract data…",
      ai_prefill: "License data was auto-filled by AI. Please verify and correct if needed.",
      sec_personal: "Personal data",
      sec_residence: "Residence",
      sec_license: "License details",
      sec_id: "ID document",
      sec_rental: "Rental summary",
      sec_sign: "Signature",
      family_name: "Family name",
      given_names: "Given names",
      birthplace: "Place of birth",
      birthdate: "Date of birth",
      street: "Street",
      number: "No.",
      city: "City",
      zip: "ZIP",
      province: "Province",
      country: "Country",
      phone: "Mobile",
      email: "Email",
      fiscal_code: "Tax code",
      license_number: "License no.",
      license_category: "Category",
      license_issue_date: "Issue date",
      license_issuing_country: "Issuing country",
      license_expiry: "Expiry",
      id_type: "ID type",
      id_type_id_card: "ID card",
      id_type_passport: "Passport",
      id_number: "Number",
      id_issue_date: "Issue date",
      id_issuer: "Issued by",
      id_expiry: "Expiry",
      scooters: "Scooters",
      plate: "plate",
      sign_here: "Sign below",
      sign_clear: "Clear",
      sign_hint: "Sign with mouse or finger in the white area.",
      accept_terms: "I specifically accept clauses 2, 4, 5, 7, 9, 10, 11, 12 of the general rental conditions (Italian Civ. Code art. 1341, 1342).",
      accept_privacy: "I have read and accept the personal data processing notice (GDPR).",
      confirm_data: "I confirm that the data entered from my driving licence and ID card is correct and truthful.",
      sign_submit: "Sign the contract",
      signing: "Signing…",
      signed_ok: "Contract signed ✓",
      signed_title: "Contract signed",
      signed_desc: "You can now proceed to secure payment via Stripe.",
      signed_short: "Contract signed ✓",
      step_hint: "Sign the contract to continue",
      fill_required: "Fill in all required fields, sign and accept the terms",
      preview_label: "Contract preview",
      preview_desc: "Review the full contract with your data filled in BEFORE signing. Required.",
      preview_open: "Show contract preview",
      preview_review_again: "Review again",
      preview_loading: "Generating preview…",
      preview_failed: "Could not generate preview",
      preview_first: "Please review the contract preview before signing",
      preview_need_fields: "Fill in all required fields above first.",
      preview_modal_label: "Preview · specimen",
      preview_modal_title: "Review the contract before signing",
      preview_modal_hint: "Scroll through all pages. When you're ready, close this window and sign.",
      preview_modal_confirm: "I've read it · proceed to sign",
      id_autofill_label: "Auto-fill from ID card",
      id_autofill_desc: "Take or upload a photo of BOTH the front AND the back of your ID card: we'll automatically fill in every field (address, fiscal code, document number…).",
      id_photo_label: "Front of ID card",
      id_photo_label_front: "Front",
      id_photo_label_back: "Back",
      id_extracting: "Extracting data…",
      id_autofilled: "Data extracted from your ID ✓ check and correct if needed",
      id_back_autofilled: "Back-side data extracted ✓ (residence updated)",
      id_autofilled_badge: "Filled from document",
      id_unreadable: "Document photo unreadable: try again with a sharper photo",
      id_back_unreadable: "Back-side photo unreadable: try again with a sharper photo",
      download: "Download PDF",
    },
    auth: { signin: "Sign in", signup: "Sign up", email: "Email", password: "Password", name: "Name", google: "Continue with Google", or: "or", sin: "Sign in", sup: "Create account", err: "Error" },
    payment: {
      cancel_title: "Flexible cancellation",
      cancel_desc: "You can cancel your booking up to 24 hours before pickup and get a full refund. To cancel, email info@vicotravel.it or call +39 335 6116528.",
    },
    dash: { title: "My bookings", empty: "No bookings yet. Book your first NIU NQiX 500!", scooter: "Scooter", dates: "Dates", qty: "Qty", total: "Total", status: "Status" },
    admin: {
      title: "Admin Panel", subtitle: "Manage bookings & fleet",
      stats: { total: "Bookings", pending: "Pending", confirmed: "Confirmed", cancelled: "Cancelled", revenue: "Estimated revenue" },
      tabs: { bookings: "Bookings", customers: "Customers", fleet: "Fleet", gallery: "Gallery", calendar: "Calendar", analytics: "Analytics", account: "Account" },
      filter_all: "All", confirm: "Confirm", cancel: "Cancel", delete: "Delete", confirm_delete: "Delete permanently?",
      empty: "No bookings",
      fleet_units: "Scooter units", fleet_full_day: "Daily rate (€)", fleet_half_day: "Afternoon (€)", fleet_multi_day: "Multi-day rate (€)", fleet_extra_helmet: "Extra helmet (€ each)", fleet_topcase: "Top case (€ each)", save: "Save changes", saved: "Saved",
      units_title: "Individual scooters",
      units_sub: "Plate and insurance code are visible only here in the admin panel — never on the public site.",
      unit_name: "Public name",
      loc_title: "Pickup & return points",
      loc_subtitle: "Customers choose one of these points while booking. Pickup and return happen at the same point.",
      loc_add_title: "Add point",
      loc_name: "Name (e.g. Camping Sass Dlacia)",
      loc_address: "Address",
      loc_notes: "Hours / notes (e.g. pickup from 9:00)",
      loc_add: "Add",
      loc_customer_label: "Customer picks the address",
      loc_customer_hint: "Use this for generic points (e.g. \"Your hotel\") where the customer will specify the venue name at booking time.",
      loc_customer_badge: "Address from customer",
      loc_address_locked: "The customer will enter the hotel name at booking",
      gallery_title: "Public gallery",
      gallery_sub: "Photos appear in the Gallery section on the homepage.",
      gallery_empty: "No photos yet. Add one below.",
      gallery_add_title: "Add photo",
      gallery_caption_ph: "Caption under the photo (optional)",
      gallery_add: "Add to gallery",
      gallery_added: "Photo added",
      gallery_too_big: "Image too large (max 8 MB)",
      gallery_pick_photo: "Pick a photo",
      loc_added: "Point added",
      loc_removed: "Point removed",
      loc_name_required: "Point name is required",
      loc_delete_confirm: "Remove this pickup point?",
      loc_empty: "No points configured — customers won't see the choice.",
      unit_plate: "Plate",
      unit_insurance: "Insurance code",
      unit_saved: "Scooter updated",
      access_denied: "Access denied. Admins only.",
      helmets: "Helmets",
      topcase: "Top case",
      cal_title: "Daily availability",
      cal_sub: "See free scooters day-by-day and temporarily block units for maintenance.",
      cal_available: "Free",
      cal_booked: "Booked",
      cal_blocked: "Blocked",
      block_title: "Temporary block",
      block_sub: "Reserve N scooters for maintenance or internal use.",
      block_qty: "Scooters to block",
      block_start: "From",
      block_end: "To",
      block_notes: "Notes (optional)",
      block_btn: "Create block",
      block_created: "Block created",
      an_title: "Revenue analytics",
      an_total_rev: "Total revenue",
      an_total_bk: "Bookings",
      an_avg_ticket: "Avg ticket",
      visits_title: "Site visits",
      visits_today: "Today",
      visits_7d: "Last 7 days",
      visits_30d: "Last 30 days",
      visits_unique: "unique",
      visits_all: "total",
      visits_visits: "Visits",
      visits_book_clicks: "Book clicks",
      visits_referrers: "Top referrers (30 d)",
      an_revenue_chart: "Monthly revenue (€)",
      an_bookings_chart: "Bookings per month",
      pw_title: "Change password",
      pw_sub: "Update your admin account password. Minimum 6 characters.",
      pw_current: "Current password",
      pw_new: "New password",
      pw_confirm: "Confirm new password",
      pw_save: "Update password",
      push_title: "Push notifications on your phone",
      push_sub: "Enable them on this device to get notified as soon as a new booking or payment comes in.",
      push_unsupported: "Your browser does not support push notifications. On iPhone add the site to your Home Screen (Safari → Share → Add to Home Screen), then open it from the Home Screen and try again.",
      push_status: "Status on this device",
      push_on: "ON",
      push_off: "OFF",
      push_denied: "· blocked by browser",
      push_enable: "Enable notifications",
      push_disable: "Disable",
      push_test: "Send test",
      push_test_sent: "Test notification sent",
      push_enabled: "Push notifications enabled on this device",
      push_disabled: "Push notifications disabled",
      push_hint: "On iPhone (iOS 16.4+): add vico-scooter.it to the Home Screen (Safari → Share → Add to Home Screen), open the app from the Home Screen and hit Enable. On Android: works directly in Chrome/Edge/Firefox.",
      pw_changed: "Password updated",
      pw_mismatch: "Passwords do not match",
      pw_min: "Password must be at least 6 characters",
      pw_all_fields: "Please fill all fields",
      gran_month: "Month", gran_week: "Week", gran_day: "Day",
      notif_title: "Notifications",
      notif_new: "New booking",
      notif_empty: "No new bookings",
      notif_clear: "Clear",
      notif_enable: "Enable desktop notifications",
      notif_enabled: "Desktop notifications enabled",
      gran_now: "Today",
      cust_title: "Customer database",
      cust_search: "Search by name, email or phone...",
      cust_export: "Export CSV",
      cust_empty: "No customers yet",
      cust_bookings: "Bookings",
      cust_total: "Total spent",
      cust_all_bookings: "All bookings",
      cust_notes: "Notes",
      view_license: "View licence",
      license_title: "Driver document",
      license_none: "No licence uploaded",
      license_delete: "Delete",
      license_delete_confirm: "Permanently delete licence photos and data?",
      license_deleted: "Licence deleted",
      license_expires_in: "Auto-delete in",
      license_expiring_today: "Deleted today",
      contract_signed: "Contract signed",
      ai_verified: "AI Verified",
      download_contract: "Download contract",
      contract_download_failed: "Could not download the contract",
    },
    license: {
      title: "Upload your driver licence",
      subtitle: "To complete your booking, please upload your licence details and photo. Required at scooter pickup.",
      driver_name: "Driver full name",
      birthdate: "Date of birth",
      number: "Licence number",
      expiry: "Expiry date",
      country: "Country of issue",
      is_intl_q: "Is your licence an International Driving Permit?",
      intl_yes_hint: "You must upload both the national and the international licence.",
      intl_no_hint: "Just upload your national licence.",
      national_photos: "National licence photos",
      intl_photos: "International licence photos",
      front: "Front",
      back: "Back",
      front_required: "Front (required)",
      back_required: "Back (required)",
      submit: "Send licence data",
      saved: "Licence saved successfully",
      fill_required: "Please fill all required fields",
      upload_national: "Upload the front of the national licence",
      upload_national_back: "Upload the back of the national licence",
      upload_international: "Upload the front of the international licence",
      upload_international_back: "Upload the back of the international licence",
      take_photo: "Take photo",
      pick_gallery: "Gallery",
      retake: "Retake",
      replace: "Change",
      upload_image: "Upload image",
      upload_hint_desktop: "JPG · PNG · max 5MB",
      autofill_hint: "Take or upload the license photo first: we'll pre-fill the fields automatically.",
      extracting: "Extracting data…",
      autofilled: "Data extracted from your licence ✓ check and correct if needed",
      autofilled_badge: "Filled from photo",
      data_label: "Licence data",
      verify_hint: "The details you type will be automatically compared with those on the licence photo. Make sure the photo is sharp and well lit.",
      done_title: "All set!",
      done_sub: "Your data is on file. See you in San Cassiano — bring the original document at pickup.",
    },
  },
  de: {
    brand: { name: "Vico's Scooter", tag: "Alta Badia" },
    nav: { fleet: "Das Modell", how: "So geht's", routes: "Routen", pricing: "Preise", availability: "Verfügbarkeit", gallery: "Galerie", faq: "FAQ", login: "Anmelden", logout: "Abmelden", dashboard: "Meine Buchungen", admin: "Admin", book: "Jetzt buchen" },
    hero: {
      kicker: "Alta Badia · Dolomiten",
      // Title: "Erlebe die Dolomiten auf eine {NEUE} Art!"
      title_pre: "Erlebe die Dolomiten",
      title_mid: "auf eine",
      title_accent: "NEUE",
      title_end: "Art!",
      sub: "Mieten Sie den neuen 100 % elektrischen e-Scooter und genießen Sie die Dolomiten — Lärmlos, Emissionenlos und Grenzenlos!",
      cta: "Scooter buchen",
      cta2: "Modell ansehen",
      electric_chip: "100% Elektrisch",
    },
    showcase: {
      label: "Die Flotte von",
      title: "Vico's Scooter",
      zero_emissions: "Null Emissionen",
      desc: "Der neue 100 % elektrische E-Scooter. Maximale Sicherheit dank ABS und TCS. Spritzig und dynamisch, ausgestattet mit verschiedenen Fahrmodi und bis zu 100 km Reichweite.",
      specs: { range: "Reichweite", speed: "Höchstgesch.", abs_tcs: "ABS + TCS", security: "Sicherheit", riders: "Sitzplätze", power: "Max. Leistung", license: "Führerschein", age: "Mindestalter", helmet: "Helm", yes: "Inklusive", riders_v: "2 Personen" },
    },
    how: { label: "So geht's", title: "Drei Schritte.\nKein Stress.", s1t: "Daten wählen", s1d: "Öffne den Kalender, wähle Abhol- und Rückgabetag.", s2t: "Bestätigen", s2d: "Gib deine Daten ein. Du erhältst sofort eine Bestätigungs-E-Mail.", s3t: "Losfahren", s3d: "Hol den Scooter in unserer Werkstatt in San Cassiano ab oder bestelle Hotel-Lieferung." },
    routes: {
      label: "Routen", title: "Die Routen\nder Dolomiten.",
      intro: "Mit dem E-Scooter gleitest du mühelos durch die Pässe, umgehst die Bus-Schlangen und findest überall Parkplatz — vor allem in Städten wie Cortina und Bruneck, wo das Auto-Parken ein Alptraum ist.",
      stats: { distance: "Distanz", duration: "Dauer", elev: "Höhenmeter" },
      cta: "Diese Route buchen",
      cta_short: "Buchen",
      download_gpx: "GPX laden",
      open_maps: "In Google Maps öffnen",
      items: [
        {
          id: "4passi",
          title: "Die 4-Pässe-Runde",
          desc: "Die klassische Sellaronda — so wie sie wirklich sein sollte: auf dem Scooter. Pordoi rauf, Sella überqueren, Gardena runter und über den Campolongo zurück. Keine Gangschaltung, kein Stress, nur Natur rundum.",
          stats: { distance: "55 km", duration: "3 h", elev: "+1 800 m" },
        },
        {
          id: "cortina",
          title: "San Cassiano → Cortina",
          desc: "Falzaregopass, die 5 Türme zur Rechten, dann hinunter zur Königin der Dolomiten. Mit dem Auto suchst du stundenlang Parkplatz — mit dem Scooter hältst du direkt am Corso Italia, gehst essen und fährst weiter.",
          stats: { distance: "35 km", duration: "1 h 15", elev: "+700 m" },
        },
        {
          id: "brunico",
          title: "San Cassiano → Bruneck",
          desc: "Die sanfteste Abfahrt: La Villa, Longega, unteres Gadertal bis Bruneck. Perfekt zum Bummeln in der Altstadt, MMM Ripa besuchen und am Abend zurück. Parken in Bruneck ist ein Auto-Albtraum — für dich: zwei Sekunden.",
          stats: { distance: "30 km", duration: "45 min", elev: "−400 m" },
        },
      ],
    },
    pricing: { label: "Tarife", title: "Drei einfache Tarife", half: "Halber Tag", full: "Tagestarif", multi: "Mehrtage", per: "pro Scooter", popular: "Bester Preis", coming_soon: "Bald verfügbar", per_day: "/Tag", flat: "Pauschal", full_desc: "1 oder 2 Tage · ganzer Tag", multi_desc: "Ab 3 Tagen · vergünstigt", half_desc: "Bis zu 4 Stunden · Probefahrt" },
    gallery: { label: "Galerie", title: "Momente auf unseren Scootern" },
    avail: { label: "Verfügbarkeit", title: "Live-Verfügbarkeit", hint: "Tage mit freien Scootern sind markiert. Wähle einen Zeitraum." },
    hygiene: {
      label: "Hygiene & Sicherheit",
      title: "Desinfizierte Helme.\nGratis Helm-Hauben.",
      intro: "Deine Gesundheit steht an erster Stelle. Jeder Helm wird nach jeder Nutzung professionell desinfiziert und bei jeder Miete schenken wir dir eine Einweg-Helm-Haube — hygienisch, frisch und immer neu.",
      free_badge: "Helm-Hauben gratis · in jeder Miete inklusive",
      item1_title: "Professionelle Desinfektion",
      item1_desc: "Jeder Helm wird nach jeder Nutzung mit antibakteriellem Spray und UV-C Licht desinfiziert. Kein geteilter Schweiß, keine Bakterien, keine Gerüche.",
      item2_title: "Gratis Einweg-Hauben",
      item2_desc: "Wir schenken dir bei jeder Miete eine atmungsaktive Einweg-Helm-Haube. Komfort, Frische und volle Hygiene unter dem Helm.",
      item3_title: "Zertifizierte Sicherheit",
      item3_desc: "Helme mit ECE 22.06 Zulassung, regelmäßig geprüft. Größen S, M, L verfügbar — vor der Abfahrt anprobieren.",
    },
    faq: {
      label: "Fragen", title: "Schnelle Antworten",
      items: [
        { q: "Brauche ich einen Führerschein?", a: "Ja. Für den NIU NQiX 500 brauchst du entweder den Führerschein B (Auto) oder A1 (Motorrad). Mindestalter 18 Jahre." },
        { q: "Ist ein Helm Pflicht?", a: "Ja, ein Helm ist gesetzlich vorgeschrieben und immer in der Miete enthalten. Du kannst Größen S, M oder L bei der Buchung wählen." },
        { q: "Kann ich stornieren?", a: "Ja, die Stornierung ist nur bis 24h vor Abholung möglich. Danach ist keine Rückerstattung mehr möglich." },
        { q: "Wie lange hält die Batterie?", a: "Der NIU NQiX 500 hat zwei Wechselakkus 72V 28Ah für eine Gesamtreichweite von ca. 95 km — mehr als genug für einen Tag." },
        { q: "Bei Regen?", a: "Kein Problem: der Scooter ist vollständig wasserdicht und für alle Wetterbedingungen straßenzugelassen." },
      ],
    },
    footer: { tag: "Let's Ride.", contact: "Kontakt", location: "Wo", hours: "Öffnungszeiten", rights: "Alle Rechte vorbehalten." },
    book: {
      title: "Buche deinen Vico's Scooter",
      step1: "Daten", step2: "Anzahl & Helme", step3: "Kontakt",
      start: "Start", end: "Ende", qty: "Scooter", tier: "Tarif",
      name: "Vollständiger Name", email: "Email", phone: "Telefon", notes: "Notizen (optional)",
      summary: "Zusammenfassung", total: "Geschätzte Summe", confirm: "Buchung bestätigen",
      success: "Buchung eingegangen!", success_d: "Du erhältst in Kürze eine Bestätigungs-E-Mail. Wir melden uns für die Abhol-Details.",
      next: "Weiter", back: "Zurück",
      auto_tier: "Tarif wird automatisch anhand der Dauer angewendet",
      pay_redirect: "Sichere Zahlung über Stripe · Karte oder Apple/Google Pay",
      helmets_title: "Inklusive Helme",
      helmets_sub: "Helm und Topcase immer inklusive · Extra-Helm +€{extra_helmet} · max. 2 Helme pro Scooter.",
      helmets_count: "Helme gesamt",
      helmets_warn: "Empfohlen mindestens 1 Helm pro Scooter.",
      helmets_max: "Maximal 2 Helme pro Scooter erreicht.",
      helmet_fee_line: "Zusatz-Helme",
      half_day_toggle: "Nur Nachmittag · €{half_day} pauschal",
      pickup: "Abholung",
      return: "Rückgabe",
      same_day: "Gleicher Tag",
      select_dates: "Tippe einen Tag im Kalender",
      select_dates_hint: "Ein Tag für Einzelmiete · Zwei Tage für Mehrtage",
      duration_choice: "Mietdauer",
      slot_choice: "Zeitfenster",
      slot_morning: "Vormittag",
      slot_afternoon: "Nachmittag",
      slot_past: "Zeitfenster vorbei",
      custom_hours_call: "Für Infos & individuelle Zeiten: +39 335 6116528",
      half_day_option: "Halber Tag",
      half_day_option_d: "Nachmittag · bis 4h · €{half_day} pauschal",
      full_day_option: "Ganzer Tag",
      full_day_option_d: "9h · €{full_day}",
      full_day_same_day_locked: "Nur ab morgen",
      same_day_notice: "Für heute ist nur der Nachmittag-Halbtag möglich (Rückgabe bis 17:00 Uhr).",
      today_multiday_blocked: "Tages- oder Mehrtagesmiete muss am Vortag gebucht werden. Wähle ein Startdatum ab morgen.",
      age_confirm: "Ich bestätige, dass sowohl der Bucher als auch die Person, die den Scooter fährt, mindestens 18 Jahre alt sind und einen gültigen Führerschein (B oder A1) besitzen.",
      age_required: "Du musst die Altersbestätigung akzeptieren, um fortzufahren",
      topcase_title: "Topcase (optional)",
      topcase_sub: "Füge einen Topcase-Koffer zum Scooter hinzu, um Rucksäcke, Einkäufe und persönliche Gegenstände zu transportieren. Max. 1 pro Scooter.",
      topcase_label: "Topcases · €20 je",
      available_label: "verfügbar",
      sold_out: "Nicht verfügbar für diese Daten",
      phone_required: "Telefonnummer ist erforderlich",
      pending_title: "Buchung in Bearbeitung",
      pending_next_step: "Nächster Schritt",
      pending_step_license: "Führerschein hochladen",
      pending_step_contract: "Vertrag unterschreiben",
      pending_step_pay: "Zahlung",
      pending_resume: "Fortsetzen",
      pending_cancel: "Abbrechen und neu starten",
      resumed: "Buchung fortgesetzt · weiter, wo du aufgehört hast",
      resume_failed: "Buchung konnte nicht fortgesetzt werden",
      cancelled: "Buchung storniert",
      recovery_open: "Link verloren",
      recovery_title: "Buchung wiederherstellen",
      recovery_desc: "Gib deine Email ein: falls du eine offene Buchung hast, schicken wir dir den Link zum Fortsetzen.",
      recovery_send: "Link senden",
      recovery_sent: "Falls du eine offene Buchung hast, haben wir dir den Link per Email geschickt.",
      recovery_failed: "Fehler beim Senden der Wiederherstellungs-Email",
      continue_license: "Weiter",
      continue_pay: "Zur Zahlung",
      step_license_hint: "Fülle die Führerscheindaten oben aus, um fortzufahren",
      continue_sign: "Weiter zur Unterschrift",
      sign_title: "Unterschreibe die Datenschutzerklärung",
      sign_sub: "Unterschreibe das Dokument unten. Die Zahlung wird automatisch freigeschaltet, sobald die Unterschrift registriert ist.",
      sign_waiting: "Warte auf Unterschrift…",
      sign_done: "Unterschrift erhalten ✓ · du kannst zur Zahlung fortfahren",
      sign_iframe_hint: "Falls das Formular nicht erscheint, ",
      sign_iframe_open: "in neuem Tab öffnen",
      sign_refresh: "Ich habe unterschrieben — Prüfen",
      sign_refresh_none: "Unterschrift noch nicht empfangen. Versuche es in ein paar Sekunden erneut.",
      sign_refresh_ok: "Unterschrift gefunden! Du kannst zur Zahlung fortfahren.",
      choose_scooter: "Wähle deinen Scooter",
      pickup_point: "Abhol- & Rückgabepunkt",
      pickup_point_hint: "Abholung und Rückgabe erfolgen am selben Punkt.",
      pickup_hotel_label: "Name deines Hotels *",
      pickup_hotel_placeholder: "z.B. Hotel Ai Pini",
      pickup_hotel_hint: "Wir liefern den Scooter direkt zu deinem Hotel.",
      pickup_hotel_hint_short: "Hotelnamen eingeben",
      choose_scooter_hint: "Jeder Scooter ist ein einzigartiges Fahrzeug: Wähle den/die gewünschten aus.",
      unit_busy: "Belegt",
      unit_selected: "Ausgewählt",
      select_scooter_required: "Wähle mindestens einen Scooter",
      your_scooters: "Deine Scooter",
    },
    contract: {
      title: "Mietvertrag",
      subtitle: "Fülle den Vertrag aus und unterschreibe. Die Zahlung wird nach der Unterschrift freigeschaltet.",
      loading: "Vertragsdaten werden geladen…",
      ai_prefill: "Führerscheindaten wurden von KI vorausgefüllt. Bitte überprüfen und ggf. korrigieren.",
      sec_personal: "Persönliche Daten",
      sec_residence: "Wohnsitz",
      sec_license: "Führerscheindaten",
      sec_id: "Ausweisdokument",
      sec_rental: "Mietübersicht",
      sec_sign: "Unterschrift",
      family_name: "Nachname",
      given_names: "Vorname",
      birthplace: "Geburtsort",
      birthdate: "Geburtsdatum",
      street: "Straße",
      number: "Nr.",
      city: "Stadt",
      zip: "PLZ",
      province: "Provinz",
      country: "Land",
      phone: "Handy",
      email: "E-Mail",
      fiscal_code: "Steuernummer",
      license_number: "Führerschein Nr.",
      license_category: "Klasse",
      license_issue_date: "Ausstellungsdatum",
      license_issuing_country: "Ausstellungsland",
      license_expiry: "Ablaufdatum",
      id_type: "Dokumenttyp",
      id_type_id_card: "Personalausweis",
      id_type_passport: "Reisepass",
      id_number: "Nummer",
      id_issue_date: "Ausstellungsdatum",
      id_issuer: "Ausgestellt von",
      id_expiry: "Ablaufdatum",
      scooters: "Scooter",
      plate: "Kennzeichen",
      sign_here: "Hier unterschreiben",
      sign_clear: "Löschen",
      sign_hint: "Mit Maus oder Finger im weißen Bereich unterschreiben.",
      accept_terms: "Ich akzeptiere ausdrücklich die Klauseln 2, 4, 5, 7, 9, 10, 11, 12 der allgemeinen Mietbedingungen (ital. ZGB Art. 1341, 1342).",
      accept_privacy: "Ich habe die Datenschutzerklärung gelesen und akzeptiert (DSGVO).",
      confirm_data: "Ich bestätige, dass die aus Führerschein und Personalausweis übernommenen Daten korrekt und wahrheitsgemäß sind.",
      sign_submit: "Vertrag unterschreiben",
      signing: "Unterschreiben…",
      signed_ok: "Vertrag unterschrieben ✓",
      signed_title: "Vertrag unterschrieben",
      signed_desc: "Du kannst nun mit der sicheren Stripe-Zahlung fortfahren.",
      signed_short: "Vertrag unterschrieben ✓",
      step_hint: "Unterschreibe den Vertrag, um fortzufahren",
      fill_required: "Bitte fülle alle Pflichtfelder aus, unterschreibe und akzeptiere die Bedingungen",
      preview_label: "Vertragsvorschau",
      preview_desc: "Sieh dir den vollständigen Vertrag mit deinen ausgefüllten Daten VOR dem Unterschreiben an. Pflicht.",
      preview_open: "Vertragsvorschau anzeigen",
      preview_review_again: "Erneut ansehen",
      preview_loading: "Vorschau wird erstellt…",
      preview_failed: "Vorschau konnte nicht erstellt werden",
      preview_first: "Bitte sieh dir die Vertragsvorschau vor der Unterschrift an",
      preview_need_fields: "Fülle zuerst alle Pflichtfelder oben aus.",
      preview_modal_label: "Vorschau · Muster",
      preview_modal_title: "Vertrag vor der Unterschrift prüfen",
      preview_modal_hint: "Scrolle durch alle 13 Seiten. Wenn du bereit bist, schließe dieses Fenster und unterschreibe.",
      preview_modal_confirm: "Gelesen · zur Unterschrift",
      id_autofill_label: "Mit Personalausweis ausfüllen",
      id_autofill_desc: "Mach oder lade Fotos der Vorderseite UND der Rückseite deines Ausweises hoch: wir füllen automatisch alle Felder aus (Adresse, Steuernummer, Dokumentnummer…).",
      id_photo_label: "Vorderseite Ausweis",
      id_photo_label_front: "Vorderseite",
      id_photo_label_back: "Rückseite",
      id_extracting: "Daten werden extrahiert…",
      id_autofilled: "Daten aus dem Ausweis erkannt ✓ bitte prüfen und ggf. korrigieren",
      id_back_autofilled: "Daten der Rückseite erkannt ✓ (Adresse aktualisiert)",
      id_autofilled_badge: "Aus dem Dokument ausgefüllt",
      id_unreadable: "Dokumentfoto nicht lesbar: bitte mit schärferem Foto erneut versuchen",
      id_back_unreadable: "Rückseite-Foto nicht lesbar: bitte mit schärferem Foto erneut versuchen",
      download: "PDF herunterladen",
    },
    auth: { signin: "Anmelden", signup: "Registrieren", email: "Email", password: "Passwort", name: "Name", google: "Mit Google fortfahren", or: "oder", sin: "Einloggen", sup: "Konto erstellen", err: "Fehler" },
    payment: {
      cancel_title: "Flexible Stornierung",
      cancel_desc: "Du kannst deine Buchung bis 24 Stunden vor der Abholung kostenlos stornieren und erhältst eine vollständige Rückerstattung. Zum Stornieren schreibe an info@vicotravel.it oder rufe +39 335 6116528 an.",
    },
    dash: { title: "Meine Buchungen", empty: "Noch keine Buchungen. Buche deinen ersten NIU NQiX 500!", scooter: "Scooter", dates: "Daten", qty: "Anzahl", total: "Summe", status: "Status" },
    admin: {
      title: "Admin-Panel", subtitle: "Buchungen & Flotte verwalten",
      stats: { total: "Buchungen", pending: "Ausstehend", confirmed: "Bestätigt", cancelled: "Storniert", revenue: "Geschätzter Umsatz" },
      tabs: { bookings: "Buchungen", customers: "Kunden", fleet: "Flotte", gallery: "Galerie", calendar: "Kalender", analytics: "Analytics", account: "Konto" },
      filter_all: "Alle", confirm: "Bestätigen", cancel: "Stornieren", delete: "Löschen", confirm_delete: "Endgültig löschen?",
      empty: "Keine Buchungen",
      fleet_units: "Anzahl Scooter", fleet_full_day: "Tagespreis (€)", fleet_half_day: "Nachmittag (€)", fleet_multi_day: "Mehrtage-Preis (€)", fleet_extra_helmet: "Extra-Helm (€/Stk)", fleet_topcase: "Topcase (€/Stk)", save: "Speichern", saved: "Gespeichert",
      units_title: "Einzelne Scooter",
      units_sub: "Kennzeichen und Versicherungscode sind nur hier im Admin-Bereich sichtbar — nie auf der öffentlichen Seite.",
      unit_name: "Öffentlicher Name",
      loc_title: "Abhol- & Rückgabepunkte",
      loc_subtitle: "Kunden wählen bei der Buchung einen dieser Punkte. Abholung und Rückgabe erfolgen am selben Punkt.",
      loc_add_title: "Punkt hinzufügen",
      loc_name: "Name (z.B. Camping Sass Dlacia)",
      loc_address: "Adresse",
      loc_notes: "Zeiten / Hinweise (z.B. Abholung ab 9:00)",
      loc_add: "Hinzufügen",
      loc_customer_label: "Kunde wählt die Adresse",
      loc_customer_hint: "Für allgemeine Punkte (z.B. 'Dein Hotel'), bei denen der Kunde den Ortsnamen bei der Buchung angibt.",
      loc_customer_badge: "Adresse vom Kunden",
      loc_address_locked: "Der Kunde gibt den Hotelnamen bei der Buchung ein",
      gallery_title: "Öffentliche Galerie",
      gallery_sub: "Fotos erscheinen im Galerie-Bereich auf der Startseite.",
      gallery_empty: "Noch keine Fotos. Füge unten eines hinzu.",
      gallery_add_title: "Foto hinzufügen",
      gallery_caption_ph: "Bildunterschrift (optional)",
      gallery_add: "Zur Galerie hinzufügen",
      gallery_added: "Foto hinzugefügt",
      gallery_too_big: "Bild zu groß (max. 8 MB)",
      gallery_pick_photo: "Foto auswählen",
      loc_added: "Punkt hinzugefügt",
      loc_removed: "Punkt entfernt",
      loc_name_required: "Name des Punktes erforderlich",
      loc_delete_confirm: "Diesen Abholpunkt entfernen?",
      loc_empty: "Keine Punkte konfiguriert — Kunden sehen keine Auswahl.",
      unit_plate: "Kennzeichen",
      unit_insurance: "Versicherungscode",
      unit_saved: "Scooter aktualisiert",
      access_denied: "Zugriff verweigert. Nur Admins.",
      helmets: "Helme",
      topcase: "Topcase",
      cal_title: "Tägliche Verfügbarkeit",
      cal_sub: "Freie Scooter Tag für Tag anzeigen und Einheiten vorübergehend für Wartung sperren.",
      cal_available: "Frei",
      cal_booked: "Gebucht",
      cal_blocked: "Gesperrt",
      block_title: "Temporäre Sperre",
      block_sub: "N Scooter für Wartung oder internen Gebrauch reservieren.",
      block_qty: "Zu sperrende Scooter",
      block_start: "Von",
      block_end: "Bis",
      block_notes: "Notizen (optional)",
      block_btn: "Sperre erstellen",
      block_created: "Sperre erstellt",
      an_title: "Umsatz-Analytics",
      an_total_rev: "Gesamtumsatz",
      an_total_bk: "Buchungen",
      an_avg_ticket: "Ø Ticket",
      visits_title: "Website-Besuche",
      visits_today: "Heute",
      visits_7d: "Letzte 7 Tage",
      visits_30d: "Letzte 30 Tage",
      visits_unique: "eindeutig",
      visits_all: "gesamt",
      visits_visits: "Besuche",
      visits_book_clicks: "Buchen-Klicks",
      visits_referrers: "Top-Quellen (30 T)",
      an_revenue_chart: "Monatlicher Umsatz (€)",
      an_bookings_chart: "Buchungen pro Monat",
      pw_title: "Passwort ändern",
      pw_sub: "Aktualisiere das Passwort deines Admin-Kontos. Mindestens 6 Zeichen.",
      pw_current: "Aktuelles Passwort",
      pw_new: "Neues Passwort",
      pw_confirm: "Neues Passwort bestätigen",
      pw_save: "Passwort aktualisieren",
      push_title: "Push-Benachrichtigungen aufs Handy",
      push_sub: "Aktiviere sie auf diesem Gerät, um sofort bei neuen Buchungen oder Zahlungen benachrichtigt zu werden.",
      push_unsupported: "Dein Browser unterstützt keine Push-Benachrichtigungen. Auf dem iPhone die Website zum Home-Bildschirm hinzufügen (Safari → Teilen → Zum Home-Bildschirm), dann von dort öffnen und erneut versuchen.",
      push_status: "Status auf diesem Gerät",
      push_on: "AKTIV",
      push_off: "INAKTIV",
      push_denied: "· vom Browser blockiert",
      push_enable: "Benachrichtigungen aktivieren",
      push_disable: "Deaktivieren",
      push_test: "Test senden",
      push_test_sent: "Testbenachrichtigung gesendet",
      push_enabled: "Push-Benachrichtigungen auf diesem Gerät aktiviert",
      push_disabled: "Push-Benachrichtigungen deaktiviert",
      push_hint: "Auf iPhone (iOS 16.4+): vico-scooter.it zum Home-Bildschirm hinzufügen (Safari → Teilen → \"Zum Home-Bildschirm\"), von dort öffnen und Aktivieren drücken. Auf Android: direkt mit Chrome/Edge/Firefox.",
      pw_changed: "Passwort aktualisiert",
      pw_mismatch: "Passwörter stimmen nicht überein",
      pw_min: "Passwort muss mindestens 6 Zeichen haben",
      pw_all_fields: "Bitte alle Felder ausfüllen",
      gran_month: "Monat", gran_week: "Woche", gran_day: "Tag",
      notif_title: "Benachrichtigungen",
      notif_new: "Neue Buchung",
      notif_empty: "Keine neuen Buchungen",
      notif_clear: "Leeren",
      notif_enable: "Desktop-Benachrichtigungen aktivieren",
      notif_enabled: "Desktop-Benachrichtigungen aktiviert",
      gran_now: "Heute",
      cust_title: "Kundendatenbank",
      cust_search: "Suche nach Name, E-Mail oder Telefon...",
      cust_export: "CSV exportieren",
      cust_empty: "Noch keine Kunden",
      cust_bookings: "Buchungen",
      cust_total: "Gesamtausgaben",
      cust_all_bookings: "Alle Buchungen",
      cust_notes: "Notizen",
      view_license: "Führerschein ansehen",
      license_title: "Fahrer-Dokument",
      license_none: "Kein Führerschein hochgeladen",
      license_delete: "Löschen",
      license_delete_confirm: "Führerschein-Fotos und -Daten endgültig löschen?",
      license_deleted: "Führerschein gelöscht",
      license_expires_in: "Auto-Löschung in",
      license_expiring_today: "Wird heute gelöscht",
      contract_signed: "Vertrag unterschrieben",
      ai_verified: "KI-Verifiziert",
      download_contract: "Vertrag herunterladen",
      contract_download_failed: "Vertrag konnte nicht heruntergeladen werden",
    },
    license: {
      title: "Führerschein hochladen",
      subtitle: "Um deine Buchung abzuschließen, lade bitte deine Führerscheindaten und ein Foto hoch. Erforderlich bei der Abholung.",
      driver_name: "Vor- und Nachname Fahrer",
      birthdate: "Geburtsdatum",
      number: "Führerscheinnummer",
      expiry: "Ablaufdatum",
      country: "Ausstellungsland",
      is_intl_q: "Ist mein Führerschein international?",
      intl_yes_hint: "Lade sowohl den nationalen als auch den internationalen Führerschein hoch.",
      intl_no_hint: "Lade nur deinen nationalen Führerschein hoch.",
      national_photos: "Fotos Nationaler Führerschein",
      intl_photos: "Fotos Internationaler Führerschein",
      front: "Vorderseite",
      back: "Rückseite",
      front_required: "Vorderseite (Pflicht)",
      back_required: "Rückseite (Pflicht)",
      submit: "Führerscheindaten senden",
      saved: "Führerschein erfolgreich gespeichert",
      fill_required: "Bitte fülle alle Pflichtfelder aus",
      upload_national: "Lade die Vorderseite des nationalen Führerscheins hoch",
      upload_national_back: "Lade die Rückseite des nationalen Führerscheins hoch",
      upload_international: "Lade die Vorderseite des internationalen Führerscheins hoch",
      upload_international_back: "Lade die Rückseite des internationalen Führerscheins hoch",
      take_photo: "Foto aufnehmen",
      pick_gallery: "Galerie",
      retake: "Neu aufnehmen",
      replace: "Ändern",
      upload_image: "Bild hochladen",
      upload_hint_desktop: "JPG · PNG · max 5MB",
      autofill_hint: "Nimm zuerst das Foto des Führerscheins auf: wir füllen die Felder automatisch aus.",
      extracting: "Daten werden extrahiert…",
      autofilled: "Daten aus dem Führerschein erkannt ✓ bitte prüfen und ggf. korrigieren",
      autofilled_badge: "Aus dem Foto ausgefüllt",
      data_label: "Führerscheindaten",
      verify_hint: "Die eingegebenen Daten werden automatisch mit denen auf dem Führerscheinfoto verglichen. Achte darauf, dass das Foto scharf und gut beleuchtet ist.",
      done_title: "Alles bereit!",
      done_sub: "Deine Daten sind gespeichert. Wir sehen uns in St. Kassian — bitte das Originaldokument zur Abholung mitbringen.",
    },
  },
};
